module.exports = __webpack_public_path__ + "static/img/mould2-1.78a70d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould2-1.png
// module id = +/b6
// module chunks = 3